import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, ClipboardCheck } from "lucide-react";
import { Button } from "../../components/ui/button";
import { SafCasePanel } from "../../components/saf/SafCasePanel";

/**
 * Phase 207 — Field Collector: physical verification of one citizen self-assessment.
 * Reached from Field → SAF Verification. The collector corrects property / floor details, enters the FINAL demand lines and
 * submits; the case then goes to the Supervisor. Sent-back cases come back here with the reviewer's remarks.
 */
export default function SafVerification() {
  const { code, safId } = useParams();
  const navigate = useNavigate();
  const [done, setDone] = useState(false);
  return (
    <div className="space-y-4" data-testid="collector-saf-verification-page">
      <div className="flex items-center gap-2">
        <Button asChild variant="ghost" size="sm" className="h-9 px-2" data-testid="collector-saf-back">
          <Link to={`/${code}/collector/field`}><ArrowLeft className="h-4 w-4 mr-1" /> Field</Link>
        </Button>
        <h1 className="text-lg font-semibold font-heading flex items-center gap-2"><ClipboardCheck className="h-5 w-5" /> SAF Verification</h1>
      </div>
      <SafCasePanel code={code} safId={safId} role="tax_collector" testIdPrefix="collector-saf"
        onDone={() => { setDone(true); setTimeout(() => navigate(`/${code}/collector/field`), 1200); }} />
      {done && <p className="text-xs text-muted-foreground text-center" data-testid="collector-saf-done">Returning to Field operations…</p>}
    </div>
  );
}
